import { ceramicPackages, warrantyInformation } from '../../data/protection-catalog'
import { useCeramicPackages } from '../../lib/use-ceramic-packages'

export interface WarrantyInformationSectionProps {
  id?: string
}

export function WarrantyInformationSection({
  id = 'warranty',
}: Readonly<WarrantyInformationSectionProps>) {
  const packages = useCeramicPackages()
  const items = packages.length > 0 ? packages : ceramicPackages

  return (
    <section className="warranty-section" id={id} aria-labelledby="warranty-heading">
      <div className="section-container guidance-panel warranty-panel">
        <div>
          <p className="eyebrow">GYEON Certified</p>
          <h2 id="warranty-heading">{warrantyInformation.heading}</h2>
          <p>{warrantyInformation.copy}</p>
          <ul className="warranty-eligibility-list">
            {items.map((item) => (
              <li key={item.id}>
                <strong>{item.displayName}</strong>
                <span>{item.productName}</span>
                <span>{item.warrantyEligible ? 'Eligible' : 'No manufacturer-backed warranty'}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
